import React from 'react';

import { AppList } from 'components/AppList';
import { ClockList } from 'components/ClockList';
import BannerCarousel from 'components/BannerCarousel';
import Row from 'components/CollectionList/Row';

/*
 * These files are lifted from pages/AppGallery/CategoryItem.js and
 * pages/ClockGallery/CategoryItem.js
 *
 * Toying with a new convention where any component that has separate
 * app or clock functionality, it will own styling or layout
 *
 * Some thoughts for future improvements down the line:
 *
 * If we move the logic to know if we are viewing the clock gallery
 * to a higher level and use Reacts new Context API to let sub
 * components know, we won't have to pass isClock or similar
 * things around
 *
 * We could also convert these to dynamic imports and bundle the
 * app and clock code separately so we only download what is necessary
 */
import AppCarouselItem, {
  ITEM_WIDTH as APP_ITEM_WIDTH
} from './app/carousel-item';
import ClockCarouselItem, {
  ITEM_WIDTH as CLOCK_ITEM_WIDTH
} from './clock/carousel-item';

const DiscoveryAppList = ({ isClock, ...props }) =>
  isClock ? (
    <ClockList {...props} />
  ) : (
    <AppList
      appDigestProps={{
        showSettings: false,
        showInstalled: true
      }}
      sortable={false}
      {...props}
    />
  );

export default ({ isClock, fscViewName, pageLayoutItems = [] }) => (
  <div>
    {pageLayoutItems.map((layoutItem, index) => {
      switch (layoutItem.type) {
        case 'BANNER_LIST':
          return (
            <BannerCarousel
              banners={layoutItem.banners}
              fscViewName={fscViewName}
              isClock={isClock}
              key={`layout-item-${index}`}
            />
          );
        // App lists categories displayed as rows for watch gallery
        case 'APP_LIST':
          return (
            <Row
              itemWidth={isClock ? CLOCK_ITEM_WIDTH : APP_ITEM_WIDTH}
              apps={layoutItem.apps}
              collectionId={layoutItem.link.resourceId}
              fscViewName={fscViewName}
              isClock={isClock}
              key={`layout-item-${index}`}
              name={layoutItem.title}
              ItemClass={isClock ? ClockCarouselItem : AppCarouselItem}
              collectionType={layoutItem.link.type.toLowerCase()}
            />
          );
        // Full array of apps displayed as one list for tracker gallery and CU1
        case 'FLAT_APP_LIST':
          return (
            <DiscoveryAppList
              apps={layoutItem.apps}
              key={`layout-item-${index}`}
              isClock={isClock}
            />
          );
        default:
        // do nothing
      }
      return undefined;
    })}
  </div>
);
